
import { Direction } from "const";

export const STEPS = {
  ProductDetail:0,
  FactSheet:1,
  SelectAccountUnit: 2,
  PaymentConfirm: 3,
  OTP: 4,
  TransactionSuccess: 5,
};



const translate = 130;
const easing = [0.7, 0, 0.3, 1];
const duration = .2;

export const pageChangeAnimation = {
  variants: {
    visible: {
      x: 0,
      opacity: 1,
    },
    hidden: direction => ({
      x: direction === Direction.Previous ? -translate : translate,
      opacity: 0,
    }),
    exit: direction => ({
      x: direction === Direction.Previous ? translate : -translate,
      opacity: 0,
    }),
  },
  initial: 'hidden',
  animate: 'visible',
  exit: 'exit',
  transition: { easing, duration },
}

// export const headerHideCollapse = {
//   variants: {
//     hidden: {
//       scaleY: .2,
//     },
//     visible: {
//       scaleY: 1,
//       // transformOrigin: 'top',
//       transition: {
//         ease: 'easeOut',
//         duration: .2,
//       },
//     },
//     exit: {
//       scaleY: 0,
//       // transformOrigin: 'top',
//     }
//   },
//   initial: 'hidden',
//   animate: 'visible',
//   exit: 'exit',
//   transition: { easing, duration },
// }